import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {ExcCoreModule, ExcTranslation} from 'exc-core-v2';
import {IExgEvent} from '../../misc/interfaces/IExgEvent';
import {ExgFilterComponent} from '../../misc/exg-filter/exg-filter.component';
import {ExgDataListComponent, ExgModalService} from 'exc-controls-v2';
import {ExgApplicationEventEmitter} from '../../misc/classes/ExgApplicationEventEmitter';
import {ExcRestService, IExcDataFilter, IExcDataPaging, IExcDataSort} from 'exc-rest-v2';
import {IExcMetaInfo} from 'exc-rest-v2/lib/interfaces/IExcMetaInfo';
import {ApplicationService} from '../../services/application.service';
import {ExgApplicationTabService} from 'exc-tab-v2';
import {EnumerationService} from '../../services/enumeration.service';
import {ExcSecurityService} from 'exc-security-v2';
import {DispositionMap3Component} from '../disposition-map3/disposition-map3.component';
import {ExgMapGeocoderService} from 'exc-map-v2';

@Component({
  selector: 'app-disposition-list2',
  templateUrl: './disposition-list2.component.html',
  styles: []
})
export class DispositionList2Component extends ExcTranslation implements AfterViewInit, OnInit, IExgEvent {
  @ViewChild('VCSummaryDataFilterControl', {read: ExgFilterComponent}) VCSummaryDataFilterControl!: ExgFilterComponent;
  @ViewChild('SOlist', {read: ExgDataListComponent}) VCSOlist!: ExgDataListComponent;
  @ViewChild(DispositionMap3Component) VCDispoMap2!: DispositionMap3Component;

  Events = new ExgApplicationEventEmitter();
  mode = 'DL';
  busy = false;

  SummaryData = {
    isLoading: true,
    searchValue: '',
    multiRoute: true,
    data: {} as any,
    schadenortData: [] as any[],
    oeData: [] as any[],
    selected: [] as any[],
    selectedObjects: [] as any[],
    state: 1,
    uiFilterEnumGroup: [
      {enmName: 'VorgangTyp', enmField: 'vorg_enmIdent_VorgangTyp', enmTable: 'Vorgang', defaultValues: [1, 16, 2, 14, 3, 23, 24]},
      {enmName: 'Schadenart', enmField: 'aue_enmIdent_SchadenArt', enmTable: 'AuftragE_EIS', enmAlt: false, enmAltTT: true}
    ],
    uiFilterSearchFields: [
      {tableField: 'adrPlz', table: 'Adresse', groupCaption: 'Schadenort'},
      {tableField: 'adrOrt', table: 'Adresse', groupCaption: 'Schadenort'},
      {tableField: 'adrStr', table: 'Adresse', groupCaption: 'Schadenort'},
      {tableField: 'aueVersicherungsnehmer', table: 'AuftragE_EIS', groupCaption: 'Schaden'},
      {tableField: 'aueSchadenOrt', table: 'AuftragE_EIS', groupCaption: 'Schaden'},
      {tableField: 'vorgNr', table: 'Vorgang'},
      {tableField: 'Bearbeiter', table: 'Vorgang'},
      {tableField: 'Bearbeiter_Handy', table: 'Vorgang'},
      {tableField: 'vorgLCU', table: 'All', groupCaption: 'Vorgang'},
      {tableField: 'vorgLCD', table: 'All', groupCaption: 'Vorgang'},
      {groupCaption: 'Vorgang', table: 'All', tableField: 'vorgCKD'},
      {table: 'Vorgang', tableField: 'vorgFrist'},
      {tableField: 'auAuftraggeberShort', table: 'Auftrag', repColumn: 'au_oeID_Auftraggeber'},
      {tableField: 'auAnsprechpartner', table: 'Auftrag'},
    ],
    uiSortFieldGroup: [
      {fieldGroup: 'Schadenort', fieldTable: 'Adresse', fieldName: 'adrPlz'},
      {fieldGroup: 'Schadenort', fieldTable: 'Adresse', fieldName: 'adrOrt'},
      {fieldGroup: 'Vorgang', fieldTable: 'All', fieldName: 'vorgLCD'},
      {fieldGroup: 'Vorgang', fieldTable: 'All', fieldName: 'vorgCRD'},
      {fieldGroup: 'Vorgang', fieldTable: 'All', fieldName: 'vorgCKD'},
      {fieldGroup: 'Vorgang', fieldTable: 'Vorgang', fieldName: 'vorgFrist'},
      {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueSchadenDatum'},
      {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueAuftragsdatum'},
      {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueOrtsterminPlan'},
      {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueOrtstermin'},
      {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueOrtstermin2'},
      {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueSchadenmeldungVU'},
      {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueFristverlaengerungBis'},
      {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueZwischenberichtDatum'},
    ],
    uiFilter: [] as any [],
    uiSort: [] as any [],
    uiSortAktiv(): any[] {
      return this.uiSort.filter((sort: any) => sort.uiValue !== 0);
    },
    MetaInfo: {
      dataPaging: {pageNo: 0, pageSize: 25} as IExcDataPaging,
      dataSort: {} as IExcDataSort,
      dataFilter: {} as IExcDataFilter,
    } as IExcMetaInfo,
    paging: {pagingPage: 0, pagingEndRow: 0, pagingPageSize: 25, pagingTotalPages: 0, pagingTotalRows: 0, pagingStartRow: 0},
    changeMultiRoute: (): void => {
      if (this.mode === 'DL') {
        this.mode = 'QS';
      } else if (this.mode === 'QS') {
        this.mode = 'DL';
      }
      this.loadSummaryData();
      // this.VCDispoMap2.refreshDestinations();
    },
    rowChange: (index: number) => {
      if (index === -1) {
        return;
      }
      // console.log('zeile change', index, 'selectedObjects:', this.SummaryData.selectedObjects.map((s: any) => s.vorgNr));
    },
    itemSelect: (index: number) => {
      // console.log('item select', index, 'selectSourceRows davor:', (this.VCSOlist.selectSourceRows || []).map((s: any) => s.vorgNr));

      this.SummaryData.selectedObjects = [...(this.VCSOlist.selectSourceRows || [])];

      // console.log('itemSelect danach selectedObjects:', this.SummaryData.selectedObjects.map((s: any) => s.vorgNr));
    },
    search(value: string): void {
      this.searchValue = value;
      this.reloadData();
    },
    pageChanged: (page: number): void => {
      if (this.SummaryData.MetaInfo.dataPaging !== undefined) {
        this.SummaryData.MetaInfo.dataPaging.pageNo = page;
      }
      this.SummaryData.reloadData();
    },
    ready: () => {
      if (this.SummaryData.schadenortData.length === 0) {
        this.SummaryData.state = 2;
      } else {
        this.SummaryData.state = 0;
      }
      this.SummaryData.isLoading = false;
    },
    loadData: (data: any, paging: any): void => {
      this.SummaryData.data = data;
      this.SummaryData.schadenortData = (this.mode === 'QS') ? data.SchadenorteQS : data.Schadenorte;
      this.applyLocalSOFilter();
      this.geocodeMissingCoordinates();
      // this.SummaryData.paging = paging.Schadenorte;
      this.SummaryData.oeData = (this.mode === 'QS') ? data.QS : data.DL;
      if (this.SummaryData.oeData.length > 0) {
        for (const dlElement of this.SummaryData.oeData) {
          Object.assign(dlElement, {
            assignedTasks: ExcCoreModule.Array.GetAll(
              this.SummaryData.data.DisponiertSchadenorteDL,
              'vorg_oid_Bearbeiter',
              dlElement.oeID
            )
          });
          Object.assign(dlElement, {
            assignedTasksRegions: [],
            assignedTasksRegionsShort: []
          });
          ExcCoreModule.Array.GetAll(
            this.SummaryData.data.DisponiertSchadenorteDL,
            'vorg_oid_Bearbeiter',
            dlElement.oeID
          ).forEach((task: any) => {
            if (task.adrPlz) {
              // Task PLZ: 2 Stellen
              dlElement.assignedTasksRegions.push(task.adrPlz.slice(0, 2));
              // Task PLZ: Stelle 1
              const region = dlElement.assignedTasksRegionsShort.find(
                (postCode: any) => postCode?.postCode === task.adrPlz.slice(0, 1)
              );
              if (!!region && (task.adrPlz && task.adrPlz.startsWith(region.postCode))) {
                region.count = region.count + 1;
              } else {
                dlElement.assignedTasksRegionsShort.push({postCode: task.adrPlz.slice(0, 1), count: 1});
              }
            }
          });

          // Sort: assignedTasksRegionsShort
          dlElement.assignedTasksRegionsShort =
            dlElement.assignedTasksRegionsShort
              .sort((dlPostCode1: any, dlPostCode2: any) =>
                dlPostCode1 && dlPostCode2 && dlPostCode1.postCode > dlPostCode2.postCode ? 1 : -1
              );

          // Sort: assignedTasksRegions
          dlElement.assignedTasksRegions =
            ExcCoreModule.Array
              .Distinct(dlElement.assignedTasksRegions)
              .sort((dlPostCode1: string, dlPostCode2: string) => dlPostCode1 > dlPostCode2 ? 1 : -1);
        }
      }
    },
    reloadData: (): void => {
      this.SummaryData.isLoading = true;
      this.SummaryData.state = 1;

      this.excRestService.get(
        this.excRestService.computeUrl('DispositionR_Summary', {
          fts: this.SummaryData.searchValue
        })
        , {MetaInfo: this.SummaryData.MetaInfo}
      ).subscribe((result) => {
        this.SummaryData.schadenortData = (this.mode === 'QS') ? result.data?.SchadenorteQS : result.data?.Schadenorte;
        this.applyLocalSOFilter();
        this.geocodeMissingCoordinates();
        // this.SummaryData.paging = result.paging?.Schadenorte;
        this.SummaryData.ready();
      });
    },
  };
  worker = {
    all: ['green', 'blue', 'yellow', 'orange', 'red'],
    green: true,
    blue: true,
    yellow: true,
    orange: true,
    red: true
  };

  constructor(
    public appSvc: ApplicationService,
    private exgApplicationTabService: ExgApplicationTabService,
    private excRestService: ExcRestService,
    public enumSvc: EnumerationService,
    public excSecurity: ExcSecurityService,
    private modal: ExgModalService,
    private geocoderService: ExgMapGeocoderService,
  ) {
    super();
    this.initEnumerations();
  }

  initEnumerations(): void {
    this.SummaryData.uiFilter = [{
      filterType: 1,
      filterGroup: 'Allgemein',
      filterField: 'isProvedUI',
      filterIdent: 'isProvedUI',
      uiCaption: 'Geprüft',
      filterCondition: {operator: '=', value: 'true'},
      uiName: 'Geprüft',
      uiValue: true
    },
      {
        filterType: 1,
        filterGroup: 'Allgemein',
        filterField: 'isProvedUI',
        filterIdent: 'isProvedUI',
        uiCaption: 'Ungeprüft',
        filterCondition: {operator: '=', value: 'false'},
        uiName: 'Ungeprüft',
        uiValue: false
      }];
    this.SummaryData.uiFilter =
      [...this.SummaryData.uiFilter, ...this.appSvc.metaInfo.dataFilter(
        this.SummaryData.uiFilterEnumGroup, this.SummaryData.uiFilterSearchFields)];
    this.SummaryData.uiSort = this.appSvc.metaInfo.dataSort(this.SummaryData.uiSortFieldGroup);
  }

  ngOnInit(): void {
    this.registerEvents();
  }

  registerEvents(): void {
    if (this.exgApplicationTabService.StateTab?.Active) {
      ExcCoreModule.Services().GlobalRefresh.subscribe(() => {
        this.VCSummaryDataFilterControl.ApplyFilter();
        this.loadSummaryData();
      });
    }
  }

  ngAfterViewInit(): void {
    this.VCSummaryDataFilterControl.ApplyFilter();
    this.loadSummaryData();
  }

  loadSummaryData(): void {
    this.SummaryData.oeData = [];
    this.SummaryData.isLoading = true;
    this.SummaryData.state = 1;
    this.VCSOlist.selectSource = [];
    this.VCSOlist.selectSourceRows = [];
    this.SummaryData.selectedObjects = [];
    this.excRestService.get(
      this.excRestService.computeUrl('DispositionR_Summary', {})
      , {MetaInfo: this.SummaryData.MetaInfo}
    ).subscribe((result) => {
      this.SummaryData.loadData(result.data, result.paging);
      this.SummaryData.ready();
    });
  }

  applyLocalSOFilter(): void {
    this.SummaryData.schadenortData = this.SummaryData.schadenortData.filter((so: any) => {
      let result = true;
      // Geprüft
      if (this.SummaryData.uiFilter
        .find(f => f.filterField === 'isProvedUI' && f.filterCondition.value === 'true')?.uiValue && !so.vorgCKD)
      {
        result = false;
      }
      // Ungeprüft
      if (this.SummaryData.uiFilter
        .find(f => f.filterField === 'isProvedUI' && f.filterCondition.value === 'false')?.uiValue && so.vorgCKD)
      {
        result = false;
      }
      if (this.SummaryData.uiFilter.find(f => f.filterField === 'isProvedUI' && f.filterCondition.value === 'true')?.uiValue &&
        this.SummaryData.uiFilter.find(f => f.filterField === 'isProvedUI' && f.filterCondition.value === 'false')?.uiValue) {
        result = true;
      }
      // VorgangTyp
      const activeVorgangTypFilter = this.SummaryData.uiFilter
        .filter(f => f.filterField === 'vorg_enmIdent_VorgangTyp' && f.uiValue);
      if (activeVorgangTypFilter.length > 0) {
        const allowedTypes = activeVorgangTypFilter.map(f => f.filterCondition.value);
        if (!allowedTypes.includes(so.vorg_enmIdent_VorgangTyp) && !allowedTypes.includes(String(so.vorg_enmIdent_VorgangTyp))) {
          result = false;
        }
      }
      return result;
    });
    this.SummaryData.selectedObjects = this.SummaryData.selectedObjects.filter(
      (so: any) => this.SummaryData.schadenortData.some((item: any) => item.vorgID === so.vorgID)
    );
    if (this.VCSOlist) {
      this.VCSOlist.selectSource = this.SummaryData.selectedObjects.map((so: any) => so.vorgID);
      this.VCSOlist.selectSourceRows = [...this.SummaryData.selectedObjects];
    }
  }

  onClickOpenTaskCheckview(task: any): void {
    if (this.excSecurity.isFeatured('TASKREAD')) {
      this.appSvc.Task.Workspace.OpenTabV2(task.vorgID);
    }
  }

  assignTasks(event: any): void {
    if (this.busy) {
      return;
    }
    // console.log('dl2 assignTasks selectedObjects:', this.SummaryData.selectedObjects.map((s: any) => s.vorgNr));
    // console.log('dl2 assignTasks selectSource:', this.VCSOlist.selectSource);
    const assignList: any[] = [];

    for (let i = 0; i < this.SummaryData?.selectedObjects?.length; i++) {
      assignList.push({
        vorgID: this.SummaryData.selectedObjects[i].vorgID,
        oeID: event.oeID,
        vorgUPT: this.SummaryData.selectedObjects[i].vorgUPT
      });
    }


    if (assignList.length > 0) {
      const seen: {[vorgID: number]: boolean} = {};
      const uniqueTasks = this.SummaryData.selectedObjects.filter((task: any) => {
        if (seen[task.vorgID]) {
          return false;
        }
        seen[task.vorgID] = true;
        return true;
      });

      const seenAssign: {[vorgID: number]: boolean} = {};
      const uniqueAssignList = assignList.filter((item: any) => {
        if (seenAssign[item.vorgID]) {
          return false;
        }
        seenAssign[item.vorgID] = true;
        return true;
      });
      this.modal.show('ModalAssignConfirmationComponent'
        , {
          title: this.getRessource('Toast.title'),
          tasks: uniqueTasks,
          DL: {fullName: event.oeName + ', ' + event.oeEName},
          mode: this.mode
        }
        , true).subscribe((answer: any) => {
        if (answer?.assign) {
          let mode = this.mode;
          if (answer?.mode) {
            mode = answer.mode;
          }
          this.busy = true;
          this.excRestService.put(
            this.excRestService.computeUrl('TaskU_MultiAssign')
            , {assignList: uniqueAssignList, mode, sendCaseAcceptToClient: answer.sendCaseAcceptToClient}
          ).subscribe((ret) => {
            if (ret.success) {
              this.modal.showToast(
                this.getRessource('Toast.assigned')
                , 'md-toast bg-green'
                , 'fa-duotone fa-arrows-down-to-people'
              );
            } else {
              this.modal.showToast(
                this.getRessource('Toast.notAssigned')
                , 'md-toast bg-orange'
                , 'fas fa-exclamation'
                );
            }
            this.loadSummaryData();
            this.busy = false;
          });
        }
      });
    }
  }

  placeClick($event: any): void {
    // console.log('placeClick vorgNr', $event.vorgNr);
    if (this.SummaryData.multiRoute) {
      const selectedIndex = this.SummaryData.selectedObjects.findIndex((so: any) => {
        return so.vorgID === $event.vorgID;
      });
      const index = this.SummaryData.schadenortData.findIndex((so: any) => {
        return so.vorgID === $event.vorgID;
      });
      if (index > -1) {
        this.VCSOlist.select(index, (selectedIndex === -1) ? true : false);
      }
    } else {

    }
  }

  calcRoute(): void {
    this.VCDispoMap2.refreshDestinations();
  }

  private geocodeMissingCoordinates(): void {
    const missing = this.SummaryData.schadenortData.filter(
      (place: any) => !place.adrLat &&
        !place.adrLng &&
        (place.adrStr || place.adrPlz)
    );
    for (const place of missing) {
      const parts =
        [place.adrPlz, place.adrOrt, place.adrStr, place.adrHNum].filter(Boolean);

      this.geocoderService.geocode({address: parts.join(' ')}).subscribe((results: any) => {
        place.adrLat = results[0].geometry.location.lat();
        place.adrLng = results[0].geometry.location.lng();

        if (place.adrID && place.adrUPT) {
          this.excRestService.post(
            this.excRestService.computeUrl('OeAdresseCUD', {oeID: 'undefined'}),
            {
              adrID: place.adrID,
              adrUPT: place.adrUPT,
              adr_enmIdent_AdresseTyp: place.adr_enmIdent_AdresseTyp,
              adrStr: place.adrStr,
              adrHNum: place.adrHNum,
              adrPlz: place.adrPlz,
              adrOrt: place.adrOrt,
              adrLkz: place.adrLkz,
              adrLat: place.adrLat,
              adrLng: place.adrLng,
            }
          ).subscribe();
        }
     });
    }
  }
}
